/***************************************************************************************/ 
 /* This file is generated. Do not edit by hand unless you 100% know what you're doing.. */ 
 /***************************************************************************************/ 
 
export enum LeasePropKey { 
    AccountStatus = "AccountStatus",
    Active = "Active",
    AutoPayEnabled = "AutoPayEnabled",
    Balance = "Balance",
    DaysPastDue = "DaysPastDue",
    DueDate = "DueDate",
    EndDate = "EndDate",
    ExternalLeaseId = "ExternalLeaseId",
    ExternalUnitId = "ExternalUnitId",
    FMSType = "FMSType",
    MoveInDate = "MoveInDate",
    MoveOutDate = "MoveOutDate",
    PaidThroughDate = "PaidThroughDate",
    PaymentStatus = "PaymentStatus",
    Rent = "Rent",
    StartDate = "StartDate",
    TenantId = "TenantId",
    UnitId = "UnitId",
    UserId = "UserId",

}